var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProjects({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.653.531A1.53 1.53 0 009.512 0H1.607C.723 0 0 .81 0 1.8v14.4c0 .99.715 1.8 1.6 1.8h11.793c.884 0 1.607-.81 1.607-1.8V6.147a1.88 1.88 0 00-.474-1.269L10.653.531zm.061 13.869H4.286c-.59 0-1.072-.405-1.072-.9s.482-.9 1.072-.9h6.428c.59 0 1.072.405 1.072.9s-.482.9-1.072.9zm0-3.6H4.286c-.59 0-1.072-.405-1.072-.9S3.696 9 4.286 9h6.428c.59 0 1.072.405 1.072.9s-.482.9-1.072.9zM9.375 5.4V1.35l4.42 4.95h-3.616c-.442 0-.804-.405-.804-.9z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjects);
export default __webpack_public_path__ + "static/media/icon_projects.56527da91b8a65873a079f9568ebbcb9.svg";
export { ForwardRef as ReactComponent };